<style scoped>
tr:last-child {
  border-bottom: none;
}

.w50 {
  width: 50%;
}

.w35 {
  width: 35%;
}

.w25 {
  width: 25%;
}

.w15 {
  width: 15%;
}

.w10 {
  width: 10%;
}

.pr25 {
  padding-right: 50px;
}
</style>
<style>
.header-label {
  font-size: 15px !important;
  font-weight: bold !important;
}

.editable a {
  color: #025db3 !important;
}

.edit-field input {
  box-shadow: none !important;
  margin: 0 !important;
}

.editable .edit-icon {
  display: none;
  font-size: 18px;
  color: #b03236;
}

.editable:hover .edit-icon {
  display: inline-block;
}

/* custom-search */
.custom-search .v-text-field__slot input {
  border-bottom: none !important;
  padding: 5px 12px !important;
  margin: 0 !important;
}

.custom-search .v-label {
  padding: 0 12px;
  top: 12px;
}

.custom-search .v-text-field__slot input:focus {
  border-bottom: none !important;
  box-shadow: none !important;
}
.loader{
  position: fixed;
    top: 50%;
    z-index: 9;
    right: 50%;
}
</style>
<template lang="pug">
div
  div.loader.center-align(v-if="loading")
    .preloader-wrapper.active
      .spinner-layer.spinner-red-only
        .circle-clipper.left
          .circle
        .gap-patch
          .circle
        .circle-clipper.right
          .circle
  v-card(v-if='contents.length')
    v-card-title
      v-layout.justify-space-between.align-center.wrap
        v-flex.sm7
        v-flex.sm5
          v-spacer
          v-text-field.custom-search.mb-0(
            v-model='search',
            append-icon='search',
            label='Search',
            single-line='',
            hide-details=''
          )
    v-card-text
      v-data-table(
        :headers='headers',
        :items='filtercontentbyTag',
        :search='search',
        v-if='contents.length'
      )
        template(v-slot:items='props')
          tr
            td {{ props.item.variantCode }}
            td.editable
              v-edit-dialog(
                :return-value.sync='props.item.availableStock',
                large,
                lazy='',
                persistent,
                @save='updateItem',
                @cancel='clearSelectedItem',
                @open='setSelectedItem(props.item)'
              )
                | {{ props.item.availableStock }} &nbsp;
                //- i.material-icons.right.edit-icon edit
                v-icon.edit-icon edit
                template(v-slot:input='')
                  v-text-field.text-xs-right.edit-field(
                    v-model='selectedItem.availableStock',
                    type='number',
                    label='Edit',
                    single-line=''
                  )
            td {{ $utils.formatter.formatDateFromNow(props.item.updatedAt) }}

        v-alert(slot='no-results', :value='true', color='red', icon='warning')
          | Your search for &quot;{{ search }}&quot; found no results.
</template>
<script>
/* eslint-disable handle-callback-err */

export default {
  props: ['inventory', 'contents'],
  data () {
    return {
      loading: false,
      request: null,
      selectedItem: {
        id: null,
        variantCode: null,
        availableStock: 0,
        productCode: null
      },
      editIndex: null,
      headers: [
        {
          text: 'Product',
          value: 'variantCode',
          align: 'left',
          class: 'header-label'
        },
        {
          text: 'Available Stocks',
          value: 'availableStock',
          align: 'left',
          class: 'header-label'
        },
        {
          text: 'Last Updated',
          value: 'updatedAt',
          align: 'left',
          class: 'header-label'
        }
      ],
      search: ''
    }
  },

  computed: {
    supplier () {
      return this.$store.state.profile.supplier
    },
    inventoryName () {
      return this.$route ? this.$route.params.inventoryName : null
    },
    filtercontentbyTag () {
      let itemfilterby = this.$route.params.inventoryName
      let filter
      if (itemfilterby === 'Conventional') {
        filter = { conventional: true }
        return this.contents.filter((item) => filter[item.tags])
      } else {
        filter = { 'The Scotch Malt Whisky Society': true }
        return this.contents.filter((item) => filter[item.tags])
      }
    }
  },
  methods: {
    isSelected (item) {
      return this.selectedItem.variantCode === item.variantCode
    },
    setSelectedItem (item) {
      this.selectedItem.id = item.id
      this.selectedItem.variantCode = item.variantCode
      this.selectedItem.availableStock = item.availableStock
      this.selectedItem.productCode = item.productCode
    },
    clearSelectedItem () {
      this.selectedItem.variantCode = null
      this.selectedItem.availableStock = null
    },
    updateItem () {
      this.loading = true
      this.$store.dispatch('auth/getAccessToken').then(accessToken => {
        this.$http.post(`${this.$config.API_URL}/item/updateinventory`, {
          itemID: this.selectedItem.productCode,
          whseID: 'WHSE',
          qty: this.selectedItem.availableStock,
          acctCode: '1-00001'
        }, {
          headers: {
            authorization: `Bearer ${accessToken}`
          }
        }).then(result => {
          if (result.data.status === 'Success') {
            this.selectedItem.availableStock = Math.max(
              this.selectedItem.availableStock,
              0
            )
            this.$store.dispatch('auth/getAccessToken').then((accessToken) => {
              this.$http
                .post(
                  `${this.$config.API_URL}/suppliers/${this.supplier.id}/inventories/${this.inventory.id}`,
                  {
                    products: [
                      {
                        variantCode: this.selectedItem.variantCode,
                        availableStock: this.selectedItem.availableStock,
                        inventoryId: this.inventory.id
                      }
                    ]
                  },
                  {
                    headers: {
                      Authorization: `Bearer ${accessToken}`
                    }
                  }
                )
                .then((result) => {
                  this.filtercontentbyTag.some((item, index) => {
                    if (item.variantCode === this.selectedItem.variantCode) {
                      item.availableStock = this.selectedItem.availableStock
                      item.updatedAt = Date.now()
                      return true
                    }
                  })
                  this.clearSelectedItem()
                  this.loading = false
                  this.$snackbar.success('Item successfully updated')
                })
                .catch((err) => {
                  this.loading = false
                  this.$snackbar.error('Item could not be updated')
                })
            })
          } else {
            this.loading = false
            this.$snackbar.error('Item could not be updated')
          }
        })
      }).catch(() => {
        this.loading = false
        this.$snackbar.error('Item could not be updated')
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/page-inventory-products.vue